// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__9bdq-","navLinks":"NavBar_navLinks__u6Fv4"};